import Vue from "vue";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import {
  numeric,
  max,
  min_value,
  max_value,
  integer,
  regex,
  required,
  email
} from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";
import zh from "vee-validate/dist/locale/zh_CN.json";
localize("en", en);
localize("zh-cn", zh);
extend("numeric", numeric);
extend("max", max);
extend("min_value", min_value);
extend("max_value", max_value);
extend("integer", integer);
extend("regex", regex);
extend("required", required);
extend("email", email);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

const regIPv4 = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const regIPv6 = /^\b(?:[A-F0-9]{1,4}:){7}[A-F0-9]{1,4}\b$/;
const regDomain = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
const regUrl = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

extend("ipv4v6", {
  validate(value) {
    return {
      required: true,
      valid: regIPv4.test(value) || regIPv6.test(value)
    };
  }
});

extend("domainName", {
  validate(value) {
    return {
      required: true,
      valid: regDomain.test(value)
    };
  }
});

extend("url", {
  validate(value) {
    return {
      required: true,
      valid: regUrl.test(value)
    };
  }
});
export default {};
